import { Component, OnInit } from '@angular/core';
import { FunctionsService } from "../../services/functions.service";
import {TranslateService} from '@ngx-translate/core';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
    selector: 'app-accessibility-statement',
    templateUrl: './accessibility-statement.component.html',
    styleUrls: ['./accessibility-statement.component.css'],
    providers: [NgxSpinnerService]
})

export class AccessibilityStatementComponent implements OnInit {
    constructor(
        private translate: TranslateService,
        public functionsService: FunctionsService
    ) {
        this.translate.setDefaultLang('en');
        this.functionsService.setTitle('accessibility.accessibility_statement');
    }

    async ngOnInit() {
        if(localStorage.getItem('language') != null){
            this.functionsService.useLanguage(localStorage.getItem('language'));
        }else{ //If the language is not specified, use default one.
            this.functionsService.useLanguage('en');
        }
    }
}